/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
} from "../../runtime/index.jsx";
export function Componente_VQ_86_81(e) {
  return (
    <span
      key={e.id}
      className={e.motivo ? `text-(--text)` : `text-(--warning)`}
      children={[
        e.motivo ? `«${e.motivo}»` : `sin motivo`,
        ` — `,
        e.solicitante,
      ]}
    />
  );
}
